var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.38 15.67C31.38 23.89 25.06 30.65 17.04 31.29C16.6 31.37 16.15 31.37 15.71 31.37C14.54 31.37 13.4 31.25 12.31 31.01C5.27 29.43 0 23.16 0 15.67C0 7.01 7.05 0 15.71 0C24.37 0 31.38 7.01 31.38 15.67Z",
    fill: "#FF009D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.3898C17.74 12.1098 18.23 11.8998 18.92 11.8998C19.56 11.8998 20.34 11.9898 21.06 12.1898L21.67 8.89984C20.42 8.45984 19.12 8.33984 17.78 8.33984C16.44 8.33984 15.39 8.54984 14.54 9.02984C13.69 9.50984 13.12 10.0498 12.8 10.8198C12.47 11.4998 12.31 12.6798 12.31 14.1298V15.4298H9.71002V19.1998H12.31V31.0298C13.4 31.2698 14.54 31.3898 15.71 31.3898C16.15 31.3898 16.6 31.3898 17.04 31.3098V19.2098H20.48V15.4398H17.04V14.2298C17.04 13.2998 17.16 12.7298 17.49 12.4098",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.b839c7cc65243bf9950064cc4da27efb.svg";
export { ForwardRef as ReactComponent };